import { LANDING_DOMAIN_PATH } from '../../constants';


export const FEEDBACK_PATH = 'feedback';

export const SENDED_CONFIRMATION_TIME = 'sendedConfirmationTime';
export const SENDED_CONFIRMATION_TIME_PATH = `${LANDING_DOMAIN_PATH}.${FEEDBACK_PATH}.${SENDED_CONFIRMATION_TIME}`;

export const SEND_CODE_DELAY_SECONDS = 120;
